import { render } from "./Ad.vue?vue&type=template&id=a4293aa4&scoped=true"
import script from "./Ad.vue?vue&type=script&lang=js"
export * from "./Ad.vue?vue&type=script&lang=js"

import "./Ad.vue?vue&type=style&index=0&id=a4293aa4&scoped=true&lang=css"

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142212-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4293aa4"]])

export default __exports__